import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import React, { useRef } from 'react';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import BlueprintCards from "../../cards/BlueprintCards";


const dayjs = require("dayjs");

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
		"& > *": {
			margin: theme.spacing(1),
			width: theme.spacing(32),
			height: theme.spacing(32),
		},
	},
	root1: {
		display: "flex",
		flexWrap: "wrap",
		"& > *": {
			margin: theme.spacing(1),
			width: theme.spacing(18) + 2,
			height: theme.spacing(18) + 2,
		},
	},
	mainTitle: {
		fontSize: 16,
		maxWidth: theme.spacing(30),
		wordWrap: "break-word",
		overflowWrap: "break-word",
		textAlign: "center",
	},
	description: {
		fontSize: 12,
		maxWidth: theme.spacing(30),
		wordWrap: "break-word",
		overflowWrap: "break-word",
		textAlign: "center",
	},
	timeStamp: {
		color: '#ccc',
		fontSize: '11px',
		textAlign: 'center'
	},

	customBorder: {
		border: `3px solid #2596be`
	},
	blueprintCard: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start'
	},
	sharedBadge: {
		padding: '0.3rem',
		width: '100%',
		textAlign: 'center',
		background: '#364150',
		color: '#fff',
		fontSize: '0.7rem',
		fontWeight: '500',
		textTransform: "capitalize",
		borderRadius: '4px 4px 0 0'
	},
	cardContent: {
		flex: 10
	},
	cardsContainer: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4,1fr)',
		gridGap: '1rem',
		gridAutoRows: '1fr',
		paddingBottom: '10px !important',
		[theme.breakpoints.down("lg")]:{
			gridTemplateColumns: 'repeat(3,1fr)',
		},
		[theme.breakpoints.down("md")]:{
			gridTemplateColumns: 'repeat(2,1fr)',
		},
		[theme.breakpoints.down("sm")]:{
			gridTemplateColumns: '1fr',
		}
	}
}));

const CardSelector = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const { list = [], isOwnBlueprint } = props;


	const onPress = (item) => {
		if (item.slug != undefined)
			props.onClick(item.slug + '/' + item._id);
		else
			props.onClick(item._id)
		if (props.onSelect != undefined) props.onSelect(item);
	};

	const dateFormat = (dateToFormat) => {
		let date = new Date(dateToFormat);
		return new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
			date.getHours(),
			date.getMinutes(),
			date.getSeconds()
		);
	};

	const primary = theme.palette.primary.main;
	const secondary = theme.palette.secondary.main;
	const selectedFontColor = theme.palette.light.main;

	return (
		<div className={`${classes.cardsContainer} blueprint-cards-container`}>
			{
			list.map((item) => (
				<BlueprintCards isOwnBlueprint={isOwnBlueprint} key={item?._id} data={item} />

				// <BlueprintCards isOwnBlueprint={isOwnBlueprint} key={item?._id} data={item} selectedBlueprint={selectedBlueprint} setSelectedBlueprint={setSelectedBlueprint} />
			))
			}
		</div>
	);
};

CardSelector.defaultProps = {
	list: [],
	selected: "",
	direction: "row",
	justify: "space-evenly",
};

CardSelector.propTypes = {
	list: PropTypes.array.isRequired,
	selected: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
	direction: PropTypes.string.isRequired,
	justify: PropTypes.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]),
};

export default CardSelector;



export const CardSelectorTemplate = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const { list = [], direction, justify } = props;

	const selectedItem = useRef(false)


	const onPress = (item) => {
		props.onClick(item)
	};

	const primary = theme.palette.primary.main;
	const secondary = theme.palette.secondary.main;
	const selectedFontColor = theme.palette.light.main;


	return (
		<Grid container direction={direction} justify={justify}>
			{list.map((item) => {

				const current = item.id;
				const selected = current === props?.value?.id;
				selectedItem.current = selected;

				return (
					<Grid id={item?.id} title1={item.title} className={classes.root} onClick={() => onPress(item)}>
						<Paper elevation={3} className={selectedItem.current ? classes.customBorder : null}>
							<Grid container direction="column" justify="center" alignItems="center" style={{ height: "100%" }}>
								<Box m={1} display="flex" justifyContent="space-between" component="span" alignItems="center">
									{item.imagePath != '' ? <img src={`data:image/png;base64,${item.imagePath}`} width="75" height='75' /> : <SettingsApplicationsIcon style={{ fontSize: 70 }} color='primary' />}

								</Box>

								<Typography ui-tour-id='title-text' className={classes.mainTitle} variant="h6" style={{ color: primary }}>
									{item?.template?.length > 15 && item.template.substring(0, 15) + '..'}
									{item?.template?.length <= 15 && item.template}
								</Typography>


								{props.actionButtons && <Box m={1} display="flex" justifyContent="space-between" component="span" alignItems="center">
									{props?.actionButtons.map(button => {
										return (
											<Button color='primary' size={button?.size ? button.size: 'small'} variant={button?.variant?button.variant:'contained'} style={{ marginLeft: 10 }} onClick={() => button.action(item)}> {button.label} </Button>
										)
									})}
								</Box>}

							</Grid>
						</Paper>
					</Grid>

				);

			})}

		</Grid>
	)

}